import { useParams } from "react-router-dom";

export const useOrganizationSlugFromParams = () => {
  const { organizationSlug } = useParams<{ organizationSlug: string }>();

  return organizationSlug;
};
